window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    document.querySelectorAll('product-form [type="submit"]').forEach(function (b) {
      b.classList.remove("loading");
      b.disabled = false;
    });
  }
});

document.addEventListener("click", async function (e) {

  const btn = e.target.closest('product-form [type="submit"]');
  if (!btn) return;

  e.preventDefault();

  if (btn.disabled || btn.classList.contains("loading")) return;

  btn.classList.add("loading");
  btn.disabled = true;

  let items = [];

  /* -------------------------
  Quantity Detection
  ------------------------- */
  let form = btn.closest('form');
  let qtyInput = (form ? form.querySelector('input[name="quantity"]') : null) ||
    document.querySelector('.yumi-quantity-input') ||
    document.querySelector('input[name="quantity"]');
  let minQtyAttr = qtyInput ? (parseInt(qtyInput.getAttribute("min")) || parseInt(qtyInput.getAttribute("data-min-qty")) || 1) : 1;
  let mainQuantity = qtyInput ? (parseInt(qtyInput.value) || minQtyAttr) : minQtyAttr;
  if (mainQuantity < minQtyAttr) {
    mainQuantity = minQtyAttr;
  }

  let mainVariant = form ? form.querySelector('[name="id"]').value : document.querySelector('product-form [name="id"]').value;

  /* -------------------------
  Bundle ID & Add-ons Collection
  ------------------------- */
  let bundleId = "YUMI-" + Date.now();
  let addonItems = [];

  /* -------------------------
  Bag Tag & Custom Print (Special Multi-Step Flow)
  ------------------------- */
  let bagtag = (form ? form.querySelector('.bagtag-radio:checked') : null) || document.querySelector('.bagtag-radio:checked');
  let bagtagCard = document.querySelector(".addon-bagtag-card");
  let bagtagCheck = bagtagCard ? bagtagCard.querySelector(".addon-checkbox") : null;

  if (bagtag && (!bagtagCheck || bagtagCheck.checked)) {
    let bagtagContainer = bagtag.closest('.bagtag-variant-item');
    let name = (form ? form.querySelector('[name="properties[Bag Tag Name]"]')?.value : null) || document.querySelector('[name="properties[Bag Tag Name]"]')?.value || "";
    let className = (form ? form.querySelector('[name="properties[Bag Tag Class]"]')?.value : null) || document.querySelector('[name="properties[Bag Tag Class]"]')?.value || "";
    let contact = (form ? form.querySelector('[name="properties[Bag Tag Contact]"]')?.value : null) || document.querySelector('[name="properties[Bag Tag Contact]"]')?.value || "";

    let printModeVal = (form ? form.querySelector('[name="properties[Bag Tag Print]"]')?.value : null) || document.getElementById('propBagTagPrint')?.value;
    let printRadioYes = document.querySelector('.bagtag-print-radio[value="yes"]:checked');
    let isPrintYes = (printModeVal === 'yes') || !!printRadioYes || !!(name && name.length > 0);

    let tagProps = {
      "Bundle": bundleId,
      "Bag Tag": bagtagContainer ? bagtagContainer.dataset.name : bagtag.dataset.name || ""
    };

    if (isPrintYes) {
      tagProps["Custom ID Print"] = "Yes";
      if (name) tagProps["Name"] = name;
      if (className) tagProps["Class"] = className;
      if (contact) tagProps["Emergency Contact"] = contact;
    }

    let isBagtagFree = bagtagCard ? (bagtagCard.getAttribute("data-is-free") === "true") : false;
    let tagVariantId = parseInt(bagtagContainer ? bagtagContainer.dataset.id : bagtag.dataset.id);
    let tagPrice = bagtagContainer ? parseFloat(bagtagContainer.dataset.price || 0) : 0;

    // If bagtag is free and price of variant is still paid (no 0rs product created yet),
    // attach to main item properties so customer is never billed Rs 200!
    if (isBagtagFree && tagPrice > 0) {
      window._yumiFreeBagTagProps = tagProps;
    } else if (!isNaN(tagVariantId)) {
      addonItems.push({
        id: tagVariantId,
        quantity: mainQuantity,
        properties: tagProps
      });
    }
  }


  /* -------------------------
  All Other Personalisation Addons (Name Patch, Name Initials, Acrylic Keychain, Stickers, etc.)
  ------------------------- */
  document.querySelectorAll(".yumi-addon-card").forEach(function (card) {
    // Skip bag tag card as it's processed above
    if (card.classList.contains("addon-bagtag-card") || card.getAttribute("data-addon-type") === "bag-tag") return;

    var checkbox = card.querySelector(".addon-checkbox");
    if (!checkbox || !checkbox.checked) return;

    var addonType = card.getAttribute("data-addon-type") || "";
    var addonName = checkbox.getAttribute("data-addon-name") || "Personalisation";
    var variantId = checkbox.getAttribute("data-variant");

    // Check for radio selection inside swatch list (e.g. Character Patch, Stickers)
    var checkedRadio = card.querySelector("input[type='radio']:checked");
    if (checkedRadio) {
      var rVar = checkedRadio.getAttribute("data-variant") || checkedRadio.getAttribute("data-id");
      if (rVar) variantId = rVar;
      var rName = checkedRadio.getAttribute("data-name");
      if (rName) addonName = rName;
    }

    // Check for text input (e.g. embroidered name / initials)
    var nameInput = card.querySelector(".addon-name-input") || card.querySelector("input[type='text']");
    var textVal = nameInput ? nameInput.value.trim() : "";

    // Fallback to hidden variant input if variantId is placeholder
    if (!variantId || variantId === "patch-001" || variantId === "initials-001" || isNaN(variantId)) {
      if (addonType.indexOf("initial") !== -1) {
        variantId = document.getElementById("initialsVariant")?.value;
      } else if (addonType.indexOf("patch") !== -1 || addonType.indexOf("name") !== -1) {
        variantId = document.getElementById("patchVariant")?.value;
      } else if (addonType.indexOf("acrylic") !== -1) {
        variantId = document.getElementById("acrylicVariant")?.value;
      } else if (addonType.indexOf("character") !== -1) {
        variantId = document.getElementById("characterVariant")?.value;
      } else if (addonType.indexOf("sticker") !== -1 || addonType.indexOf("story") !== -1) {
        variantId = document.getElementById("stickerVariant")?.value;
      } else if (addonType.indexOf("tumbler") !== -1 || addonType.indexOf("bottle") !== -1 || addonType.indexOf("sipper") !== -1) {
        variantId = document.getElementById("tumblerVariant")?.value;
      } else if (addonType.indexOf("cap") !== -1 || addonType.indexOf("hat") !== -1) {
        variantId = document.getElementById("capVariant")?.value;
      }
    }

    if (variantId && !isNaN(parseInt(variantId))) {
      var addonProps = {
        "Bundle": bundleId,
        "Bundle Type": addonName
      };
      if (textVal) {
        addonProps[addonName] = textVal;
      } else if (checkedRadio && checkedRadio.getAttribute("data-name")) {
        addonProps[addonName] = checkedRadio.getAttribute("data-name");
      }

      addonItems.push({
        id: parseInt(variantId),
        quantity: mainQuantity,
        properties: addonProps
      });
    }
  });

  /* -------------------------
  Assemble Cart Items
  ------------------------- */
  let mainItemProps = {};
  if (addonItems.length > 0) {
    mainItemProps["Bundle"] = bundleId;
    mainItemProps["Bundle Type"] = "Main Product";
  }
  if (window._yumiFreeBagTagProps) {
    Object.assign(mainItemProps, window._yumiFreeBagTagProps);
    delete window._yumiFreeBagTagProps;
  }

  if (Object.keys(mainItemProps).length > 0 || addonItems.length > 0) {
    items.push({
      id: mainVariant,
      quantity: mainQuantity,
      properties: Object.keys(mainItemProps).length > 0 ? mainItemProps : undefined
    });
    addonItems.forEach(function (addon) {
      items.push(addon);
    });
  } else {
    // Standalone product (no addons selected)
    items.push({
      id: mainVariant,
      quantity: mainQuantity
    });
  }


  /* -------------------------
  Complimentary Packaging (Yellow Drawstring Bag)
  Handled centrally by yumi-free-gift.js based on order threshold (>= ₹1,000)
  ------------------------- */

  /* -------------------------
  Add All to Cart
  ------------------------- */

  try {
    let cartNotification = document.querySelector("cart-notification");
    let sections = cartNotification ? cartNotification.getSectionsToRender().map(s => s.id).join(',') : '';

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const parsedState = await response.json();

    if (response.ok) {
      if (cartNotification) {
        cartNotification.renderContents(parsedState);
      } else {
        window.location.href = "/cart";
      }
    } else {
      console.error("Shopify Cart API Error:", parsedState);
      alert("Failed to add items to cart: " + (parsedState.description || "Unknown error"));
    }
  } catch (err) {
    console.error("Network Error:", err);
    alert("Failed to connect to cart. Please try again.");
  } finally {
    btn.classList.remove("loading");
    btn.disabled = false;
  }

});